import { MAX_TIME_LEFT_TIMEOUT_MODAL } from 'components/sessionTimeOut/constants';

export const INITIAL_TIME_LEFT = { minLeft: MAX_TIME_LEFT_TIMEOUT_MODAL - 1, secLeft: 59 };
